import React from 'react';
import './StateRestorationDialog.css';

function StateRestorationDialog({ restorationInfo, onRestore, onDiscard, nightMode }) {
  if (!restorationInfo || !restorationInfo.hasState) {
    return null;
  }

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const formatLastSaved = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMinutes = Math.floor((now - date) / (1000 * 60));
    
    if (diffMinutes < 1) {
      return 'just now';
    } else if (diffMinutes < 60) {
      return `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`;
    } else if (diffMinutes < 1440) {
      const hours = Math.floor(diffMinutes / 60);
      return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    } else {
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    }
  };

  return (
    <div className={`restoration-overlay ${nightMode ? 'night-mode' : ''}`}>
      <div className="restoration-dialog">
        <div className="restoration-header">
          <h3>🔄 Restore Previous Match?</h3>
          <p>We found a match in progress from {formatLastSaved(restorationInfo.lastSaved)}</p>
        </div>
        
        <div className="restoration-preview">
          <div className="match-preview">
            <div className="team-info">
              <span className="team-name">{restorationInfo.teamA || 'Team A'}</span>
              <span className="score">{restorationInfo.scoreA}</span>
            </div>
            <div className="vs">vs</div>
            <div className="team-info">
              <span className="team-name">{restorationInfo.teamB || 'Team B'}</span>
              <span className="score">{restorationInfo.scoreB}</span>
            </div>
          </div>
          
          <div className="match-details">
            <div className="detail-item">
              <span className="label">Time:</span>
              <span className="value">{formatTime(restorationInfo.time)}</span>
            </div>
            {restorationInfo.isEditing && (
              <div className="detail-item editing-indicator">
                <span className="label">Status:</span>
                <span className="value">✏️ Editing existing match</span>
              </div>
            )}
          </div>
        </div>
        
        <div className="restoration-actions">
          <button 
            className="restore-btn"
            onClick={onRestore}
          >
            ✅ Restore Match
          </button>
          <button 
            className="discard-btn"
            onClick={onDiscard}
          >
            🗑️ Start Fresh
          </button>
        </div>
        
        <div className="restoration-note">
          <small>💡 Tip: Your scoreboard automatically saves progress to prevent data loss from accidental refreshes</small>
        </div>
      </div>
    </div>
  );
}

export default StateRestorationDialog;
